import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import LoadingTable from 'components/LoadingTable';
import Scrollbar from 'components/Scrollbar';

import { useTheme } from '@mui/material/styles';

export default function CategoryAssignments({
  isLoading,
  categoryAssignments,
  data
}: {
  categoryAssignments: any;
  isLoading: boolean;
  data:any
}) {
  return (
    <>
      <Scrollbar
        sx={{
          width: '100%',
          maxWidth: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '300px'
        }}
        // @ts-ignore
        scrollStyles={{
          bar: {
            backgroundColor: '#d49e24'
          },
          track: {
            backgroundColor: '#F4F6F8',
            width: 8
          }
        }}
      >
        <TableContainer sx={{ minWidth: '100%' }}>
          <Table>
            {isLoading && data?.length === 0 ? (
              <LoadingTable />
            ) : (
              <TableBody>
                {data?.map((item: any) => {
                  return (
                    <TableRow key={item?.id}>
                      <TableCell
                        sx={{
                          fontSize: '12px',
                          color: '#637381'
                        }}
                      >
                        <Box
                          sx={{
                            padding: '5px',
                            borderRadius: '5px',
                            backgroundColor: '#f4f9fc',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {item?.id}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: '12px',
                          color: '#637381'
                        }}
                      >
                        {item?.category}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: '12px'
                        }}
                      >
                        {item?.total}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
            {/* {true && <EmptyTable message="لا يوجد مواعيد فى الوقت الحالى" />} */}
          </Table>
        </TableContainer>
      </Scrollbar>
    </>
  );
}
